import { DropdownObjectType } from '../../shared/types';

export interface TaxonomyEntityFormGroup {
  label: string;
  type: DropdownObjectType;
  description: string;
}

export interface TaxonomyResponse {
  message: string;
  taxonomy: Taxonomy[];
}

export interface Taxonomy {
  taxonomy_id: string;
  taxonomy_name: string;
  taxonomy_description: string;
  created_on: string;
  linked_queue_groups: string[];
  version_id: string;
  version_status: string;
  version_created_on: string;
  version_created_by: string;
  version_updated_on: string;
  version_updated_by: string;
  version_history_details: any;
  selected_taxonomy_version: any;
  isPublished?: boolean;
  taxonomy_owner_name?: string;
}

export interface LocalTaxonomy extends Taxonomy {
  taxonomy_id: string;
  taxonomy_name: string;
  taxonomy_description: string;
  created_on: string;
  linked_queue_groups: string[];
  version_id: string;
  version_status: string;
  version_created_on: string;
  version_created_by: string;
  version_updated_on: string;
  version_updated_by: string;
}

export interface LinkedItem {
  description: string;
  label: string;
}

export interface TaxonomyRequest {
  taxonomy_id: string;
  entity_name: string;
  entity_type: string;
  entity_description: string;
  linked_items_type: string;
  linked_entities: LinkedItem[];
}

export interface TaxonomyCreateRequest {
  taxonomy_name: string;
}

export interface TaxonomyCloneRequest {
  taxonomy_id: string;
  version_id: string;
  taxonomy_name: string;
}

export interface TaxonomyDeleteRequest {
  taxonomy_id: string;
}

export interface TaxonomyGetByIDRequest {
  data: any;
  taxonomy_id: string;
}

export interface TaxonomyPublishRequest {
  taxonomy_id: string;
  record_id: string;
}

export interface TaxonomyReleaseForReviewRequest {
  taxonomy_id: string;
  record_id: string;
}

export interface entitiesHubData {
  taxonomy_id: string;
  entity_name: string;
  entity_type: string;
  entity_description: string;
  linked_Items_Type: string;
  linked_entities: LinkedItem[];
  created_on: string;
  created_by: string;
}

export interface EntityUpdateRequest {
  taxonomy_id: string;
  entity_name: string;
  entity_type: string;
  entity_description: string;
  linked_items_type: string;
  linked_entities: LinkedItem[];
  entity_id: string;
}

export interface TaxonomyUpdateRequest {
  taxonomy_name: string;
  taxonomy_id: string;
  taxonomy_description: string;
  linked_queue_groups: [];
}

export interface GenerateInsightsRequest{
  taxonomy_id: string;
  record_id: string;
  input: {
    contact_id_list: []
  };
  input_type: string
}

export interface GetInsightsRequest{
  batch_id: string
}

export interface RerunTestRequest {
  batch_id: string
}

export interface DeleteTestRequest {
  batch_id: string
}

export function isTaxonomyPublished(taxonomy: Taxonomy): boolean {
  if (!taxonomy.version_history_details || !Array.isArray(taxonomy.version_history_details)) {
    return false;
  }

  return taxonomy.version_history_details.some((version: any) =>
    version.status === 'published'
  );
}
